import { get, post, put, Delete } from "../axios";

// 题目管理-列表
export const questionManageList = (params) => get("/web/question/manage/list", params);

// 题目管理-新增
export const questionManageAdd = (params) => post("/web/question/manage/add", params);

// 题目管理-编辑
export const questionManageUpdate = (params) => put("/web/question/manage/update", params);

// 题目管理-删除
export const questionManageDelete = (id) =>
    Delete("/web/question/manage/delete/" + id, "");

// 题目管理-详情
export const questionManageView = (id) => get("/web/question/manage/view/" + id, "");


